import { CANCEL_ORDER_API } from '../constants/AppConstants';

export default async (requestBody) => {
  try {
    const response = await fetch(CANCEL_ORDER_API, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });

    return { ok: response.status === 200 };
  } catch (error) {
    return { ok: false };
  }
};
